import React from 'react';
import MyRoutes from '../routes/MyRoutes';

const MyLayout = () => <MyRoutes />

export default MyLayout;